import type Player from "@vimeo/player";

// These rejections leave the video paused, which is expected, so they aren't
// errors:
// - AbortError: the video was paused or another video was loaded before
//   playback started (e.g. the student moved to the next lesson right away).
// - NotAllowedError: the browser's autoplay policy blocked playback (e.g. a
//   lesson opened from an external link with no click). The video stays
//   paused until the student presses play.
export default async function playVimeoVideo(player: Player): Promise<void> {
  try {
    await player.play();
  } catch (error) {
    const name = (error as Error | undefined)?.name;

    if (name !== "AbortError" && name !== "NotAllowedError") {
      throw error;
    }
  }
}
